import React, { useEffect, useState, useContext } from 'react';
import { LanguageContext } from 'contexts/LanguageContext';
import {
	//   EditFilled,
	UserAddOutlined,
	WhatsAppOutlined,
	HighlightOutlined,
	LeftCircleOutlined,
	InfoCircleOutlined,
} from '@ant-design/icons';
import { api } from 'services/api';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { Card, Select, Input, Tooltip, Skeleton } from 'antd';
import message from '../../utils/messageWithScroll';
import PermissionIndex from './Permissions';
import '../../styles/createGroupIndex.css';
import { FormattedMessage } from 'react-intl';

function EditGroupIndex({ number, editingGroup, setData }) {
	const { dictionary } = useContext(LanguageContext);
	const [users, setUsers] = useState([]);
	const [listOfNumbers, setListOfNumbers] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [selectedNumbers, setSelectedNumbers] = useState([]);
	const [domain, setDomain] = useState('');
	const [isPermissions, setIsPermissions] = useState(false);
	const [groupName, setGroupName] = useState('');
	const [groupId, setGroupId] = useState();
	const [isUsersSelected, setIsUsersSelected] = useState(false);
	const [isNumbersSelected, setIsNumbersSelected] = useState(false);
	const [isGroupNameFilled, setIsGroupNameFilled] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const { Option } = Select;

	useEffect(() => {
		setIsNumbersSelected(selectedNumbers.length > 0);
		setIsUsersSelected(selectedUsers.length > 0);
		setIsGroupNameFilled(groupName.trim() !== ''); // Verifica se o nome do grupo não está vazio
	}, [selectedNumbers, selectedUsers, groupName]);

	useEffect(() => {
		window.BX24.init(async () => {
			const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };
			const domain = auth.domain;
			setDomain(domain);

			await getUsersName(domain);
			await getClientGroups(domain);
		});

		const getClientGroups = async (domain) => {
			setDomain(domain);
			await getUsersName(domain);
		};

		const getUsersName = async (domain) => {
			const request = {
				domain,
			};

			const users = await api.post('getAllUsers', request);
			setUsers(users.data);
		};

		setListOfNumbers([...number.numbers.actives, ...number.numbers.inactives]);

		setGroupName(editingGroup.groupName);
		setGroupId(editingGroup.groupId);
		setSelectedUsers(editingGroup.users.map((user) => user.id));
		setSelectedNumbers(editingGroup.numbers.map((number) => number.id));

		setTimeout(() => {
			setIsLoading(false);
		}, 2000);
	}, [number.numbers.actives, number.numbers.inactives, editingGroup]);

	const sendUpdated = async () => {
		const usersToSend = users.filter((user) => selectedUsers.includes(user.id));

		const data = {
			id: groupId,
			name: groupName,
			users: usersToSend,
			numbers: selectedNumbers,
		};

		const request = {
			domain,
			data,
		};

		await api
			.post('editPermissionGroup', request)
			.then((data) => {
				message.success(dictionary.edited_group_success);

				setData((prevState) => {
					return [...prevState, data];
				});
			})
			.catch((err) => {
				if (err.message) {
					message.error(err.message);
				} else {
					message.error(dictionary.edited_group_error);
				}
			});

		setIsPermissions(true);
	};

	const goToPermissions = () => {
		setIsPermissions(true);
	};

	if (isPermissions) {
		return <PermissionIndex />;
	}

	return (
		<div id="create-group-content">
			<button
				role="button"
				className="text-bold btn-create-group btn-return"
				onClick={() => goToPermissions()}
			>
				<LeftCircleOutlined /> <FormattedMessage id="back" />{' '}
			</button>
			<div id="form-create-group">
				<Card
					title={
						<h3 className="text-bold title-create-group">
							<FormattedMessage id="edit_new_permission_group" />{' '}
						</h3>
					}
					id="form-create-group"
				>
					{isLoading ? (
						<Skeleton />
					) : (
						<>
							<div>
								<label htmlFor="groupName">
									<h3>
										<FormattedMessage id="group_name" />{' '}
										<Tooltip title={<FormattedMessage id="i_permission_group_name" />}>
											<InfoCircleOutlined
												style={{
													color: '#08AAF2',
												}}
											/>
										</Tooltip>
									</h3>
								</label>
								<HighlightOutlined className="icon-forms" />
								<Input
									id="groupName"
									type="text"
									name="groupName"
									placeholder={dictionary.placeholder_group_name}
									className="input-forms"
									value={groupName}
									onChange={(event) => setGroupName(event.target.value)}
								/>

								<label htmlFor="numberNames">
									<h3>
										<FormattedMessage id="whatsapp_numbers" />{' '}
										<Tooltip title={<FormattedMessage id="i_whatsapp" />}>
											<InfoCircleOutlined
												style={{
													color: '#08AAF2',
												}}
											/>
										</Tooltip>
									</h3>
								</label>
								<WhatsAppOutlined className="icon-forms" />
								<Select
									id="numberNames"
									name="numberNames"
									size="large"
									className="input-forms"
									placeholder={<FormattedMessage id="placeholder_whats_app" />}
									mode="multiple"
									maxTagCount={2}
									maxTagPlaceholder={(omittedValues) => `+ ${omittedValues.length}`}
									value={selectedNumbers}
									onChange={(value) => setSelectedNumbers(value)}
								>
									{listOfNumbers.length &&
										listOfNumbers.map((number) => (
											<Option key={number.id} value={number.id}>
												{`${number.name} - ${number.number}`}
											</Option>
										))}
								</Select>

								<label htmlFor="users">
									<h3>
										<FormattedMessage id="users" />{' '}
										<Tooltip title={<FormattedMessage id="i_users" />}>
											<InfoCircleOutlined
												style={{
													color: '#08AAF2',
												}}
											/>
										</Tooltip>
									</h3>
								</label>
								<UserAddOutlined className="icon-forms" />
								<Select
									name="users"
									size="large"
									className="input-forms"
									placeholder={<FormattedMessage id="placeholder_users" />}
									mode="multiple"
									maxTagCount={2}
									maxTagPlaceholder={(omittedValues) => `+ ${omittedValues.length}`}
									value={selectedUsers}
									onChange={(value) => {
										if (value.includes(0)) {
											setSelectedUsers([0]);
										} else {
											setSelectedUsers(value);
										}
									}}
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) =>
										option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									notFoundContent={dictionary.user_not_found}
								>
									{users.map((user) => (
										<Option key={user.id} value={user.id}>
											{user?.fullName || ''}
										</Option>
									))}
								</Select>
							</div>
							<button
								onClick={sendUpdated}
								className="text-bold btn-create-group btn-save"
								disabled={!isUsersSelected || !isNumbersSelected || !isGroupNameFilled}
								style={{ cursor: 'pointer' }}
							>
								<FormattedMessage id="save" />
							</button>
						</>
					)}
				</Card>
			</div>
		</div>
	);
}

export default NumberConsumer(EditGroupIndex);
